import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useColors } from 'legacyfrontend/hooks/useColors';
import { FiRefreshCw } from 'react-icons/fi';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    minWidth: '300px',
    maxWidth: '500px',
    width: '90%',
    borderRadius: '12px',
    padding: '16px',
  },
}));

const DialogHeader = styled(DialogTitle)({
  textAlign: 'center',
  fontSize: '1.5rem',
  fontWeight: 600,
  paddingBottom: 0,
});

const ContentWrapper = styled(DialogContent)({
  padding: '24px 16px !important',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const MessageText = styled(Box)({
  textAlign: 'center',
  marginTop: '16px',
  fontSize: '1rem',
});

const ActionButtons = styled(DialogActions)({
  padding: '8px 24px 24px',
  justifyContent: 'center',
});

const ConfirmButton = styled(Button)({
  padding: '10px 24px',
  borderRadius: '8px',
  fontWeight: 600,
});

const IconContainer = styled(Box)({
  width: '100px',
  height: '100px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '16px',
});

const RefreshIcon = styled(FiRefreshCw)({
  fontSize: '4rem',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  animation: 'spin 2s infinite linear',
});

const RefreshModal = ({ open, onConfirm }) => {
  const { background, text } = useColors();

  return (
    <StyledDialog
      aria-describedby='refresh-dialog-description'
      aria-labelledby='refresh-dialog-title'
      disableScrollLock={false}
      onClose={() => {}} // Prevenir cierre
      open={open}
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
        },
      }}
    >
      <DialogHeader id='refresh-dialog-title'>Actualizar Resultados</DialogHeader>

      <ContentWrapper>
        <IconContainer
          sx={{
            backgroundColor: `${background}20`,
          }}
        >
          <RefreshIcon
            sx={{
              color: background,
              '@keyframes spin': {
                from: { transform: 'rotate(0deg)' },
                to: { transform: 'rotate(360deg)' },
              },
              animation: 'spin 2s infinite linear',
            }}
          />
        </IconContainer>

        <MessageText id='refresh-dialog-description'>
          <Typography align='center' variant='body1'>
            Los precios y disponibilidad de vuelos pueden haber cambiado.
          </Typography>
          <Box mt={2}>
            <Typography align='center' variant='body1'>
              Vamos a actualizar los resultados para que puedas ver la información más reciente.
            </Typography>
          </Box>
        </MessageText>
      </ContentWrapper>

      <ActionButtons>
        <ConfirmButton
          onClick={onConfirm}
          sx={{
            backgroundColor: background,
            color: text,
            '&:hover': {
              backgroundColor: `${background}dd`,
            },
          }}
          variant='contained'
        >
          Actualizar
        </ConfirmButton>
      </ActionButtons>
    </StyledDialog>
  );
};

export default RefreshModal;
